import { colors } from '../../../theme';
import { createOwnUpStyle } from '../../style';
export var OwnUpSectionBreakStyle = createOwnUpStyle({
  textAlign: 'center',
  margin: '40px auto',
  maxWidth: '1177px',
  '& > svg': {
    width: '100%',
    stroke: colors.GREY
  },
  variants: {
    smallAndUp: {
      margin: '50px auto'
    },
    modal: {
      width: '100%',
      margin: '20px 0 30px 0',
      borderBottom: "1px solid ".concat(colors.GREY_ALT),
      '& > svg': {
        display: 'none'
      }
    }
  }
});